<template>
  <div></div>
</template>

<script>
import { AuthService } from '@/services/auth.service'

export default {
  async created() {
    await AuthService.makeLogout()
  },
}
</script>
